import { Controller } from "@hotwired/stimulus"

// Hydrates personalized match-score badges into product cards without putting
// user-specific HTML inside the cached condensed-card fragment.
//
// Stimulus fires slotTargetConnected for targets already in the DOM when the
// controller connects, so there is no connect() pass: it would hydrate every
// slot a second time. Templates are indexed by product id as they connect so a
// page of results costs one lookup per slot rather than a scan per slot.
export default class extends Controller {
  static targets = ["slot", "template"]

  initialize() {
    this.templatesByProductId = new Map()
  }

  disconnect() {
    this.templatesByProductId.clear()
  }

  slotTargetConnected(slot) {
    this.hydrate(slot)
  }

  templateTargetConnected(template) {
    const productId = template.dataset.productId
    this.templatesByProductId.set(productId, template)

    this.slotTargets
      .filter(slot => slot.dataset.productId === productId)
      .forEach(slot => this.hydrate(slot, template))
  }

  templateTargetDisconnected(template) {
    const productId = template.dataset.productId

    if (this.templatesByProductId.get(productId) === template) {
      this.templatesByProductId.delete(productId)
    }
  }

  hydrate(slot, template = this.templatesByProductId.get(slot.dataset.productId)) {
    if (!template) return

    slot.replaceChildren(template.content.cloneNode(true))
  }
}
